<h2 mat-dialog-title>{{ is_edit_mode ? 'Editar categoría' : 'Nueva categoría' }}</h2>

<mat-dialog-content>
  <form [formGroup]="form" class="d-flex flex-column gap-2">
    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Nombre</mat-label>
      <input matInput formControlName="name" maxlength="255" />
    </mat-form-field>

    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Descripción</mat-label>
      <textarea matInput formControlName="description" rows="4"></textarea>
    </mat-form-field>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-flat-button color="accent" type="button" (click)="save()" [disabled]="loading() || form.invalid">Guardar</button>
</mat-dialog-actions>
